import React, { useState } from "react";
import { motion } from "framer-motion";
import { SITE } from "@/data/site";

// Authentic WhatsApp brand icon SVG
const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413"/>
  </svg>
);

const PhoneIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

// Instagram brand icon SVG
const InstagramIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
  </svg>
);

export default function FloatingButtons() {
  const [hovered, setHovered] = useState(null);

  const entrance = (delay) => ({
    initial: { opacity: 0, x: 90, scale: 0.5 },
    animate: { opacity: 1, x: 0, scale: 1 },
    transition: { delay, type: "spring", stiffness: 240, damping: 17 },
  });

  const beat = (delay) => ({
    animate: { scale: [1, 1.16, 1], rotate: [0, -4, 4, 0] },
    transition: { duration: 0.9, delay: delay + 2.2, repeat: Infinity, repeatDelay: 2.7, ease: "easeInOut" },
  });

  return (
    <>
    {/* MOBİL: altta ikili dikdörtgen bar — sol Hemen Ara, sağ WhatsApp */}
    <motion.div
      data-testid="mobile-cta-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 shadow-[0_-8px_30px_rgba(0,0,0,0.25)]"
      initial={{ y: 90 }}
      animate={{ y: 0 }}
      transition={{ delay: 0.9, type: "spring", stiffness: 220, damping: 22 }}
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a
        data-testid="mobile-call-btn"
        href={`tel:${SITE.phoneRaw}`}
        className="relative overflow-hidden flex items-center justify-center gap-2.5 h-[58px] text-[13px] font-semibold tracking-[0.1em] uppercase text-[#1d1403] active:brightness-95"
        style={{ background: "linear-gradient(135deg, #e8c37e 0%, #c89a5a 50%, #a97f3e 100%)" }}
      >
        <span className="pv-shine" aria-hidden />
        <PhoneIcon className="w-5 h-5" /> Hemen Ara
      </a>
      <a
        data-testid="mobile-whatsapp-btn"
        href={`https://wa.me/${SITE.whatsappRaw}?text=${encodeURIComponent("Merhaba, masaj randevusu hakkında bilgi almak istiyorum.")}`}
        target="_blank"
        rel="noreferrer"
        className="relative overflow-hidden flex items-center justify-center gap-2.5 h-[58px] text-[13px] font-semibold tracking-[0.1em] uppercase text-white active:brightness-95"
        style={{ background: "linear-gradient(135deg, #34d269 0%, #1faf52 55%, #128c3e 100%)" }}
      >
        <span className="pv-shine pv-shine-delay" aria-hidden />
        <WhatsAppIcon className="w-5 h-5" /> WhatsApp Mesaj
      </a>
    </motion.div>

    {/* MASAÜSTÜ: dikey yuvarlak butonlar */}
    <div className="hidden md:flex fixed bottom-6 right-6 z-40 flex-col items-center gap-3">
      {/* Instagram */}
      <motion.div {...entrance(1.0)} style={{ animation: "pv-float 3.6s ease-in-out 2.2s infinite" }} className="relative flex items-center justify-end" onMouseEnter={() => setHovered("ig")} onMouseLeave={() => setHovered(null)}>
        {hovered === "ig" && (
          <div className="absolute right-[68px] top-1/2 -translate-y-1/2 bg-forest-deep text-cream text-[11px] font-medium tracking-[0.14em] uppercase px-4 py-2.5 whitespace-nowrap rounded-sm shadow-lg animate-[pv-fade_0.3s_ease-out] before:content-[''] before:absolute before:right-[-5px] before:top-1/2 before:-translate-y-1/2 before:w-2.5 before:h-2.5 before:bg-forest-deep before:rotate-45">
            Instagram · @masajsalonu_bursa
          </div>
        )}
        <motion.div {...beat(0)}>
        <a
          data-testid="floating-instagram"
          href={SITE.socials.instagram}
          target="_blank"
          rel="noreferrer"
          aria-label="Instagram @masajsalonu_bursa"
          className="group relative w-[50px] h-[50px] md:w-[58px] md:h-[58px] rounded-full flex items-center justify-center text-white transition-transform duration-300 hover:scale-110"
          style={{
            background: "linear-gradient(45deg, #f9ce34 0%, #ee2a7b 45%, #6228d7 100%)",
            boxShadow: "0 10px 28px -6px rgba(238,42,123,0.5), inset 0 2px 0 rgba(255,255,255,0.35), inset 0 -2px 0 rgba(0,0,0,0.12)",
          }}
        >
          <span className="absolute inset-0 rounded-full ring-1 ring-white/20" />
          <InstagramIcon className="relative w-[26px] h-[26px]" />
        </a>
        </motion.div>
      </motion.div>

      {/* WhatsApp */}
      <motion.div {...entrance(1.18)} style={{ animation: "pv-float 3.6s ease-in-out 2.6s infinite" }} className="relative flex items-center justify-end" onMouseEnter={() => setHovered("wa")} onMouseLeave={() => setHovered(null)}>
        {hovered === "wa" && (
          <div className="absolute right-[68px] top-1/2 -translate-y-1/2 bg-forest-deep text-cream text-[11px] font-medium tracking-[0.14em] uppercase px-4 py-2.5 whitespace-nowrap rounded-sm shadow-lg animate-[pv-fade_0.3s_ease-out] before:content-[''] before:absolute before:right-[-5px] before:top-1/2 before:-translate-y-1/2 before:w-2.5 before:h-2.5 before:bg-forest-deep before:rotate-45">
            WhatsApp ile yaz
          </div>
        )}
        <motion.div {...beat(1.2)}>
        <a
          data-testid="floating-whatsapp"
          href={`https://wa.me/${SITE.whatsappRaw}?text=${encodeURIComponent("Merhaba, Diamond Life Masaj Bursa için randevu almak istiyorum.")}`}
          target="_blank"
          rel="noreferrer"
          aria-label="WhatsApp ile yaz"
          className="group relative w-[50px] h-[50px] md:w-[58px] md:h-[58px] rounded-full flex items-center justify-center text-white transition-transform duration-300 hover:scale-110"
          style={{
            background: "radial-gradient(circle at 30% 25%, #4ee07a 0%, #25D366 45%, #1eaf52 100%)",
            boxShadow: "0 10px 28px -6px rgba(37,211,102,0.55), inset 0 2px 0 rgba(255,255,255,0.35), inset 0 -2px 0 rgba(0,0,0,0.12)",
          }}
        >
          <span className="absolute inset-0 rounded-full ring-1 ring-white/20" />
          <span className="absolute inset-[-6px] rounded-full bg-[#25D366]/30 animate-ping" />
          <WhatsAppIcon className="relative w-7 h-7" />
        </a>
        </motion.div>
      </motion.div>

      {/* Phone */}
      <motion.div {...entrance(1.36)} style={{ animation: "pv-float 3.6s ease-in-out 3.0s infinite" }} className="relative flex items-center justify-end" onMouseEnter={() => setHovered("ph")} onMouseLeave={() => setHovered(null)}>
        {hovered === "ph" && (
          <div className="absolute right-[68px] top-1/2 -translate-y-1/2 bg-forest-deep text-cream text-[11px] font-medium tracking-[0.14em] uppercase px-4 py-2.5 whitespace-nowrap rounded-sm shadow-lg animate-[pv-fade_0.3s_ease-out] before:content-[''] before:absolute before:right-[-5px] before:top-1/2 before:-translate-y-1/2 before:w-2.5 before:h-2.5 before:bg-forest-deep before:rotate-45">
            Hemen Ara · {SITE.phoneDisplay}
          </div>
        )}
        <motion.div {...beat(2.4)}>
        <a
          data-testid="floating-phone"
          href={`tel:${SITE.phoneRaw}`}
          aria-label={`Telefon ${SITE.phoneDisplay}`}
          className="group relative w-[50px] h-[50px] md:w-[58px] md:h-[58px] rounded-full flex items-center justify-center transition-transform duration-300 hover:scale-110"
          style={{
            background: "linear-gradient(135deg, #f0d99e 0%, #c89a5a 35%, #a07530 70%, #d4ad6a 100%)",
            color: "#2a1d08",
            boxShadow: "0 10px 28px -6px rgba(168,121,50,0.55), inset 0 2px 0 rgba(255,255,255,0.4), inset 0 -2px 0 rgba(0,0,0,0.12)",
          }}
        >
          <span className="absolute inset-0 rounded-full ring-1 ring-white/30" />
          <PhoneIcon className="relative w-[26px] h-[26px]" />
        </a>
        </motion.div>
      </motion.div>
    </div>
    </>
  );
}
